import React, { useContext, useState, useEffect } from 'react';
import './WelcomeModal.css';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import FlyUpModal from '../../modals/FlyUpModal';
import ModalOverlay from '../../modals/ModalOverlay';
import { AppContext } from '../../../../AppContext';
import { withTranslation } from 'react-i18next';
import { Card, Icon, Image } from 'semantic-ui-react'

const browseIcon = "https://cdn.obsess-vr.com/ferragamo/welcome_modal/Browse.svg"
const exploreIcon = "https://cdn.obsess-vr.com/ferragamo/welcome_modal/Explore.svg"
const productIcon = "https://cdn.obsess-vr.com/ferragamo/welcome_modal/Product.svg"
const quizIcon = "https://cdn.obsess-vr.com/ferragamo/welcome_modal/Quiz.svg"
const wishlistIcon = "https://cdn.obsess-vr.com/ferragamo/welcome_modal/Wishlist.svg"

const WelcomeModal = ({ t }) => {
    const { history, pushHistoryWithReset } = useContext(ThreeJSWorldContext);
    const { setShowWelcomeModal } = useContext(AppContext);

    const onModalHidden = () => {
        setShowWelcomeModal(2)
    }

    const renderWelcomeContent = () => {
        return (
            <div className='welcome-modal-content' id="firstScreen">
                <div className='welcome-main-text'>
                    <div className="welcome-option">
                        <div className="imgDiv">
                            <img src={browseIcon} alt="Browse" />
                        </div>
                        <div className="icon-detail">
                            <p className="icon-heading">{t('cta1CoverLegend')}</p>
                            <p className="icon-content">{t('mouseIconCover')}</p>
                        </div>
                    </div>
                    <div className="welcome-option">
                        <div className="imgDiv">
                            <img src={productIcon} alt="Product" />
                        </div>
                        <div className="icon-detail">
                            <p className="icon-heading">{t('cta2CoverLegend')}</p>
                            <p className="icon-content">{t('productIconCover')}</p>
                        </div>

                    </div>
                    <div className="welcome-option">
                        <div className="imgDiv">
                            <img src={exploreIcon} alt="Explore" />
                        </div>
                        <div className="icon-detail">
                            <p className="icon-heading">{t('cta3CoverLegend')}</p>
                            <p className="icon-content">{t('exploreIconCover')}</p>
                        </div>

                    </div>
                    <div className="welcome-option">
                        <div className="imgDiv">
                            <img src={wishlistIcon} alt="Wishlist" />
                        </div>
                        <div className="icon-detail">
                            <p className="icon-heading">{t('cta4CoverLegend')}</p>
                            <p className="icon-content">{t('wishlistIconLegend')}</p>
                        </div>

                    </div>
                    <div className="welcome-option">
                        <div className="imgDiv">
                            <img src={quizIcon} alt="Quiz" />
                        </div>
                        <div className="icon-detail">
                            <p className="icon-heading">{t('cta5CoverLegend')}</p>
                            <p className="icon-content">{t('quizIconLegend')}</p>
                        </div>
                    </div>
                </div>
                <div className='welcome-button-main' onClick={() => {onModalHidden()}}>
                    {t('ctaMainCoverLegend')}
                </div>
            </div>
        )
    }

    return (
        <FlyUpModal 
            extraClassName={`welcome-modal-container`} 
            isOpaque 
            textPopup 
            hideCloseIcon 
            isImageLoaded 
            onModalHidden={onModalHidden} 
            modalType={'welcome'}
        >
            <ModalOverlay />
            {renderWelcomeContent()}
        </FlyUpModal>
    );
}

export default withTranslation()(WelcomeModal);